import { render, staticRenderFns } from "./BillableHandler.vue?vue&type=template&id=212dc196&scoped=true"
import script from "./BillableHandler.vue?vue&type=script&lang=js"
export * from "./BillableHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212dc196",
  null
  
)

export default component.exports